import React from "react"
import { Link } from "gatsby"
import { Row, Col, Carousel } from "react-bootstrap"
import Axios from "axios"
import { PATH_URL, REQUEST_URL } from "../../../config"
import AW_men from "./../../../img/carousel/AW_men.jpg"
import AW_women from "./../../../img/carousel/AW_women.jpg"
import AW_student from "./../../../img/carousel/AW_student.jpg"
import AW_student_1 from "./../../../img/carousel/AW_student_1.jpg"
import AW_student_2 from "./../../../img/carousel/AW_student_2.jpg"
import AW_kid from "./../../../img/carousel/AW_kid.jpg"
import AW_cartoon from "./../../../img/carousel/AW_cartoon.jpg"
import AW_happy from "./../../../img/carousel/AW_cartoon.jpg"
import AW_2density from "./../../../img/carousel/AW_2density.jpg"
import AW_pillow from "./../../../img/carousel/AW_pillow.jpg"

const category = [
  {
    category_name: "หมวดหมู่รองเท้า",
    category_name_eng: "Product Category",
    category_items: [
      {
        name: "รองเท้าผู้ชาย",
        name_eng: "MEN",
        img: AW_men,
        link: "https://shop.adda.co.th/product-category/man/",
      },
      {
        name: "รองเท้าผู้หญิง",
        name_eng: "WOMEN",
        img: AW_women,
        link: "https://shop.adda.co.th/product-category/woman/",
      },
      {
        name: "รองเท้านักเรียน",
        name_eng: "SCHOOL SHOES",
        img: AW_student,
        link: "https://shop.adda.co.th/product-category/student_c/",
        // items: [
        //   {
        //     img: AW_student_1,
        //     link: "https://shop.adda.co.th/product-category/student_c/",
        //   },
        //   {
        //     img: AW_student_2,
        //     link: "https://shop.adda.co.th/product-category/student_c/",
        //   },
        // ],
      },
      {
        name: "รองเท้าเด็ก",
        name_eng: "KIDS",
        img: AW_kid,
        link: "https://shop.adda.co.th/product-category/kid/",
      },
      {
        name: "ตัวติดรองเท้า / อุปกรณ์เสริม",
        name_eng: "ACCESSORIES",
        img: AW_cartoon,
        link: "https://shop.adda.co.th/product-category/หมวดอื่นๆ/",
      },
      {
        name: "COMING SOON",
        name_eng: "COMING SOON",
        img: "",
        link: "",
      },
    ],
  },
  {
    category_name: "เทคโนโลยี",
    category_name_eng: "Technology",
    category_items: [
      {
        name: "ADDA 2Density",
        name_eng: "ADDA 2Density",
        img: AW_2density,
        link: "",
        // link: "https://shop.adda.co.th/product-category/2density/",
      },
      {
        name: "ADDA Pillow Foam",
        name_eng: "ADDA Pillow Foam",
        img: AW_pillow,
        link: "",
        // link: "https://shop.adda.co.th/product-category/man/pillow-foam/",
      },
    ],
  },
]

class CarouselSlide extends React.Component {
  state = {
    nameimg: "",
    index: 0,
    show_view: false,
    img_path: [
      PATH_URL + "style/01.jpg",
      PATH_URL + "style/02.jpg",
      PATH_URL + "style/03.jpg",
    ],
  }

  componentDidMount = async () => {
    // await Axios.post(REQUEST_URL + "/secstyle/", {}).then(response => {
    //   // console.log(response)
    //   if (response.data.status) {
    //     this.setState({
    //       nameimg: response.data.data[0].nameimg,
    //     })
    //     this.props.ChkStyle(true, response.data.data[0].nameimg)
    //   }
    // })
    this.checkScreen()
    window.addEventListener("resize", this.checkScreen)
    setTimeout(() => {
      this.props.ChkStyle(true, [])
      this.setState({
        show_view: true,
      })
    }, 200)
  }

  checkScreen = () => {
    const isMobile = window.innerWidth < 770
    this.setState({ isMobile })
  }

  render() {
    const { isMobile } = this.state
    return (
      <div style={{ padding: "0px", marginBottom: "10px" }}>
        {category.map((cate, index) => (
          <div
            hidden={!this.state.show_view}
            key={index}
            style={{ paddingLeft: "5px", paddingRight: "5px" }}
          >
            <Row style={{ marginLeft: "5px" }}>
              <p
                style={{
                  fontWeight: "bold",
                  fontSize: isMobile ? "24px" : "40px",
                }}
              >
                {cate.category_name}
              </p>
            </Row>

            <Row style={{ marginLeft: "5px", marginRight: "5px" }}>
              {cate.category_items.map((item, i) => (
                <Col
                  lg={4}
                  md={4}
                  sm={6}
                  xs={6}
                  key={i}
                  style={{ marginBottom: "15px" }}
                >
                  <Link
                    to={item.link || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{ textDecoration: "none" }}
                    onClick={e => {
                      if (!item.link) {
                        e.preventDefault()
                      }
                    }}
                  >
                    <div
                      className="category-card"
                      style={{
                        border: "1px solid #e5e5e5",
                        padding: "5px",
                        textAlign: "center",
                        background: "#fff",
                        borderRadius: "5px",
                      }}
                    >
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "1 / 1",
                          overflow: "hidden",
                          background: "#f5f5f5",
                        }}
                      >
                        {item.items && item.items.length > 0 ? (
                          <Carousel interval={3000} indicators controls>
                            {item.items.map((sub, j) => (
                              <Carousel.Item key={j}>
                                <img
                                  src={sub.img}
                                  alt={item.name_eng}
                                  style={{
                                    width: "100%",
                                    height: "100%",
                                    objectFit: "cover",
                                  }}
                                />
                              </Carousel.Item>
                            ))}
                          </Carousel>
                        ) : item.img ? (
                          <img
                            src={item.img}
                            alt={item.name}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: "100%",
                              height: "100%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: isMobile ? "28px" : "38px",
                              fontWeight: "bold",
                              color: "#999",
                            }}
                          >
                            COMING SOON
                          </div>
                        )}
                      </div>

                      <div
                        style={{
                          borderTop: "1px solid #ddd",
                          padding: "8px",
                          fontSize: isMobile ? "20px" : "30px",
                          color: "#333",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {item.name}
                      </div>
                    </div>
                  </Link>
                </Col>
              ))}
            </Row>
          </div>
        ))}
      </div>
    )
  }
}

export default CarouselSlide
